import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../helpers/connectRedux'

import { Page, Spinner } from '../../components'
import { checkSessionAction } from '../../store/actions'
import { AnyAction } from 'redux'

type Props = DispatchProp<AnyAction>

class Splash extends PureComponent<Props> {
  // The saved language is already applied on load (LiteralsService.getInitialLanguage).
  public componentDidMount() {
    const { dispatch } = this.props
    setTimeout(() => {
      dispatch(checkSessionAction())
    }, 1000)
  }

  public render(): ReactNode {
    return (
      <Page style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </Page>
    )
  }
}

export default connectRedux(null, Splash)
